import Image from "next/image";
import { Link } from "@/app/config/navigation";
import React from "react";

export function Logo() {
  return (
    <Link href="/">
      <Image
        alt="MiniCodeLeader logo"
        src="/icons/logo.svg"
        className="w-20 h-20 md:w-[56px] md:h-[56px]"
        width={35}
        height={35}
      />
    </Link>
  );
}
